export default {"src":"/_next/static/media/arrow-carousel-right.9c5af671.svg","height":29,"width":28,"blurWidth":0,"blurHeight":0};